import moment from 'moment'
import Utils from '../../utils/Utils'
import { applyHbSelectionToMatch } from '../../utils/channelFilter'
import { isBsuid } from '../../utils/whatsappIdentity'

const PANEL_URL = process.env.VUE_APP_API_PANEL;
const BROADCAST_URL = process.env.VUE_APP_API_BROADCAST;
const LIVE_SOCKET = process.env.VUE_APP_SOCKET_LIVE;
const BROADCAST_SOCKET = process.env.VUE_APP_SOCKET_BROADCAST;
const FACEBOOK_URL = process.env.VUE_APP_API_FACEBOOK;
const MAIN_URL = process.env.VUE_APP_API;
const PANEL_SOCKET = process.env.VUE_APP_SOCKET_PANEL;

export default {
  asyncForEach: async (array, callback) => {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  },
  dispatchStatusMap: {
    FAIL: 0,
    DRAFT: 1,
    SCHEDULE: 2,
    SENT: 3,
    INSUFFICIENT_CREDITS: 4,
    PROCESSING: 5,
  },
  phoneCountries: [],
  version: {
    number: '1.0.52',
    build: '2042',
    time: '10/12/2021 16:54'
  },
  api: {
    api: MAIN_URL,
    apiPanel: PANEL_URL,
    apiPanelLive: PANEL_SOCKET,
    apiBroadcast: BROADCAST_SOCKET,
    broadcast: BROADCAST_URL,
    apiFacebook: FACEBOOK_URL,
    live: LIVE_SOCKET,
    devLive: LIVE_SOCKET
  },
  alarm: {
    isActive: false,
    tolerance: null,
    display: '',
    counter: null,
    dialogYellow: false,
    dialogRed: false
  },
  lostConnection: {
    isActive: false,
  },
  breadcrumbs: {
    title: '',
    help: null,
    paths: [],
    counter: null
  },
  advancedSearch: {
    match: {
      period: 7,
      cdt: {
        $gte: moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.sssZ'),
        $lte: moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss.sssZ')
      },
      monetaryValue: {
        $gte: '',
        $lte: ''
      },
      ih: {
        $in: []
      },
      hb: [],
      dialogue: 'all',
      tags: [],
      rating: [],
      live: 5,
      attendants: [],
      departments: [],
      cIdentifiers: [],
      cIdentifierFill: true,
      cResponse: '',
      cResponseIdentifiers: [],
      cFinished: 'all',
      faqCategory: 'all',
      r: 'all'
    },
    options: {
      chatbots: [],
      identifiers: [],
      departments: [{ label: 'Todos', value: null }, { label: 'Primário', value: 'Primário' }],
      attendants: []
    },
    gauge: {
      count: 0,
      total: 0,
      average: 0
    }
  },
  advancedSearchCrm: {
    match: {
      cResponse: '',
      tags: [],
      dynamicFilter: []
    }
  },
  expandedTags: false,
  async requestMatch() {
    let match = {
      accountId: this.account._id,
      cdt: {
        $gte: moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.sssZ'),
        $lte: moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.sssZ')
      }
    }
    let advancedSearch = await Utils.asyncClone(this.advancedSearch.match)
    let advancedOptions = await Utils.asyncClone(this.advancedSearch.options)
    advancedSearch.period = this.advancedSearch.match.period
    advancedSearch.cdt.$gte = this.advancedSearch.match.cdt.$gte
    advancedSearch.cdt.$lte = this.advancedSearch.match.cdt.$lte
    let user = await Utils.asyncClone(this.user)
    if (user.permission >= 13) {
      if (advancedSearch.ih.$in && advancedSearch.ih.$in.length > 0) {
        match.ih = {
          $in: advancedSearch.ih.$in.filter(f => f !== 'all')
        }
      } else {
        match.ih = {
          $in: []
        }
        await this.asyncForEach(advancedOptions.chatbots, each => {
          match.ih.$in.push(each.value)
        })
      }
    } else {
      if (advancedSearch.ih.$in && advancedSearch.ih.$in.length > 0) {
        match.ih = {
          $in: advancedSearch.ih.$in.filter(f => f !== 'all')
        }
      }
    }
    if (advancedSearch.period !== null) {
      advancedSearch.cdt.$gte = new Date()
      advancedSearch.cdt.$lte = new Date()
      if (advancedSearch.period && advancedSearch.period !== 1) {
        advancedSearch.cdt.$lte.setDate(advancedSearch.cdt.$lte.getDate())
      } else if (advancedSearch.period) {
        advancedSearch.cdt.$lte.setDate(advancedSearch.cdt.$lte.getDate() - 1)
      }
      if (advancedSearch.period == 99) {
        advancedSearch.cdt.$gte.setDate(new Date(advancedSearch.cdt.$gte.getFullYear(), advancedSearch.cdt.$gte.getMonth(), 1).getDate())
      } else if (advancedSearch.period) {
        if (advancedSearch.period === 1) {
          advancedSearch.cdt.$gte.setDate(advancedSearch.cdt.$gte.getDate() - advancedSearch.period)
        } else {
          advancedSearch.cdt.$gte.setDate(advancedSearch.cdt.$gte.getDate() - (advancedSearch.period - 1))
        }
      } else {
        advancedSearch.cdt.$gte.setDate(advancedSearch.cdt.$gte.getDate() - advancedSearch.period)
      }
      advancedSearch.cdt.$gte.setHours(0, 0, 0, 0)
      advancedSearch.cdt.$lte.setHours(23, 59, 59, 999)
    }

    match.cdt.$gte = moment(advancedSearch.cdt.$gte).format('YYYY-MM-DDTHH:mm:ss.sssZ')
    match.cdt.$lte = moment(advancedSearch.cdt.$lte).format('YYYY-MM-DDTHH:mm:ss.sssZ')

    // BEGIN: HAS ATTACHMENTS
    if (advancedSearch.hasAttachments) {
      match.hasAttachments = true
    }else{
      delete match.hasAttachments;
    }

    // BEGIN: _ID
    if (advancedSearch.cResponse.match(/^[0-9a-fA-F]{24}$/)) {
      match._id = advancedSearch.cResponse
    } else if (advancedSearch.cResponse.match(/^[12]\d{12}$/)) {
      match.cdt = moment(parseInt(advancedSearch.cResponse)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
    } else {
      // BEGIN: C -> RESPONSE AND IDENTIFIERS
      if (advancedSearch.cResponse && advancedSearch.cResponse.length >= 2) {
        let cResponse = {}
        if (advancedSearch.cResponse[0] === ':') {
          let advancedIdentifierAndWord = advancedSearch.cResponse
          advancedIdentifierAndWord = advancedIdentifierAndWord.replace(':', '').split(' ')
          cResponse = {
            identifier: advancedIdentifierAndWord[0],
            $or: [{ resposta: { $regex: advancedIdentifierAndWord[1], $options: 'i' } }, { message: { $regex: advancedIdentifierAndWord[1], $options: 'i' } }]
          }
        } else if (advancedSearch.cResponseIdentifiers.length > 0) {
          cResponse = {
            identifier: { $in: advancedSearch.cResponseIdentifiers },
            $or: [{ resposta: { $regex: advancedSearch.cResponse, $options: 'i' } }, { message: { $regex: advancedSearch.cResponse, $options: 'i' } }]
          }
        } else {
          cResponse = { $or: [{ resposta: { $regex: advancedSearch.cResponse, $options: 'i' } }, { message: { $regex: advancedSearch.cResponse, $options: 'i' } }] }
        }
        if (!match?.$or)
          match.$or = []

        match.$or.push({ phone: advancedSearch.cResponse })

        /// Contato só-BSUID não tem telefone para casar: sem esta cláusula, colar
        /// o BSUID na busca não encontra a conversa. Só é aplicada quando o termo
        /// tem formato de BSUID, para não somar condição inútil em toda busca.
        if (isBsuid(advancedSearch.cResponse)) {
          match.$or.push({ bsuid: String(advancedSearch.cResponse).trim() })
        }

        match.$or.push({
          $and: [
            {
              c: {
                $elemMatch: cResponse
              }
            }
          ]
        })
      }
    }
    // BEGIN: C -> IDENTIFIERS
    if (advancedSearch.cIdentifiers.length > 0) {
      advancedSearch.cIdentifiers = advancedSearch.cIdentifiers.filter(f => f !== 'all')
      if (advancedSearch.cIdentifierFill) {
        if (!match.$and) {
          match.$and = []
        }
        await this.asyncForEach(advancedSearch.cIdentifiers, each => {
          match.$and.push({
            c: {
              $elemMatch: {
                identifier: each,
                resposta: { '$ne': '' },
                resposta: { '$ne': true }
              }
            }
          })
        })
      } else {
        if (!match.$or) {
          match.$or = []
        }
        await this.asyncForEach(advancedSearch.cIdentifiers, each => {
          match.$or.push({
            $nor: [
              {
                c: {
                  $elemMatch: {
                    identifier: each
                  }
                }
              }
            ]
          })
          match.$or.push({
            c: {
              $not: {
                $elemMatch: {
                  identifier: each,
                  resposta: { '$ne': '' },
                  resposta: { '$ne': true }
                }
              }
            }
          })
        })
      }
    }

    //BEGIN: MonetaryValue
    if (advancedSearch.monetaryValue && advancedSearch.monetaryValue.$gte !== '' && advancedSearch.monetaryValue.$lte !== '') {
      if (!match.$and) {
        match.$and = []
      }
      match.$and.push({
        'monetaryValue.value': {
          $gte: advancedSearch.monetaryValue.$gte,
          $lte: advancedSearch.monetaryValue.$lte
        }
      })
    } else if (advancedSearch.monetaryValue && advancedSearch.monetaryValue.$gte !== '') {
      if (!match.$and) {
        match.$and = []
      }
      match.$and.push({
        'monetaryValue.value': {
          $gte: advancedSearch.monetaryValue.$gte,
        }
      })
    } else if (advancedSearch.monetaryValue && advancedSearch.monetaryValue.$lte !== '') {
      if (!match.$and) {
        match.$and = []
      }
      match.$and.push({
        'monetaryValue.value': {
          $gte: 0,
          $lte: advancedSearch.monetaryValue.$lte
        }
      })
    }

    // BEGIN: CFinished
    if (advancedSearch.cFinished === 'finished') {
      if (!match.$and) {
        match.$and = []
      }
      match.$and.push({
        $or:[
          {c: {
            $elemMatch: {
              exit: true
            }
          }},
          { exit: true }
        ]
      })

    }

    if (advancedSearch.cFinished === 'incomplete') {
      if (!match.$nor) {
        match.$nor = []
      }
      match.$nor.push({
        $or:[
          {c: {
            $elemMatch: {
              exit: true
            }
          }},
          { exit: true }
        ]
      })
    }

    // BEGIN: TAGS
    if (!advancedSearch.tags.includes('all') && advancedSearch.tags.length > 0) {
      let arrayTags = advancedSearch.tags.map(t => [t])
      match.$or = [{ tags: { $in: advancedSearch.tags } }, { tags: { $in: arrayTags } }]
    }
    // BEGIN: PERMISSION -> MANAGER
    if (user.permission === 13) {
      if (!match.$and) match.$and = []
      match.$and.push({
        $or: [
          { 'liveChat.department': { $in: user.department } },
          { 'zion.departments': { $in: user.department } },
          { 'zion.departments': { $size: 0 } },
          { 'liveChat.attendant': user.n },
          { 'zion.attendants': user._id },
          { 'attendants.id': user._id },
          { 'zion': { $exists: false } }
        ]
      })
    }
    // BEGIN: PERMISSION -> ATTENDANTS
    let permission = await Utils.asyncClone(this.permission)
    let users = await Utils.asyncClone(this.users)
    if (user.permission >= 14) {
      if (permission.conversations[user.permission].view === 'all') {
        // DO NOTHING
      } else if (permission.conversations[user.permission].view === 'bots') {
        if (!match.$and) match.$and = []
        match.$and.push({
          $or: [
            { 'liveChat.attendant': user.n },
            { 'zion.attendants': user._id },
            { 'attendants.id': user._id }
          ]
        })
      } else if (permission.conversations[user.permission].view === 'only') {
        if (!match.$and) match.$and = []
        match.$and.push({
          $or: [
            { 'liveChat.attendant': user.n },
            { 'zion.attendants': user._id }
          ]
        })
      }
    } else {
      if (advancedSearch.attendants.length > 0) {
        /// Tres caminhos de registro do atendente, todos necessarios: `zion.attendants`
        /// (atual), `attendants.id` (legado, imune a renomeacao e a homonimo) e o
        /// nome (legado antigo, unico caminho quando o id nao foi gravado).
        let matchAttendants = {
          $or: [{
            'zion.attendants': {
              $in: advancedSearch.attendants
            }
          }, {
            'attendants.id': {
              $in: advancedSearch.attendants
            }
          }]
        }
        /// Uma condicao por atendente selecionado. O ramo por nome cobre a
        /// conversa legada, que registra o atendente em `attendants[].name` e
        /// nao em `zion.attendants` - sem ele, o atendente some do resultado.
        /// `main.users` pode ter entrada parcial sem `n` (ver updateUserStatus),
        /// dai o guard.
        let attendantNames = new Set()
        await this.asyncForEach(advancedSearch.attendants, each => {
          let attendantName = users[each] && users[each].n
          if (!attendantName || attendantNames.has(attendantName)) return
          attendantNames.add(attendantName)
          matchAttendants.$or.push(
            {
              attendants: {
                $elemMatch: {
                  name: attendantName
                }
              }
            }
          )
        })
        if (match.$and) {
          match.$and.push(matchAttendants)
        } else {
          match.$and = [matchAttendants]
        }
      }
    }

    // BEGIN: LIVE
    if (advancedSearch.live !== null) {
      switch (advancedSearch.live) {
        case 1:
          if (!match.$and) {
            match.$and = []
          }
          match.$and.push({
            c: {
              $elemMatch: {
                inputType: 'live'
              }
            }
          })
          match['live.isConnected'] = false
          match['live.isResponded'] = false
          break
        case 2:
          match['live.isConnected'] = true
          if (match.$and) {
            match.$and.push({
              $or: [
                { 'live.isResponded': false },
                { 'live.isResponded': { $exists: false } }
              ]
            })
          } else {
            match.$and = [
              {
                $or: [
                  { 'live.isResponded': false },
                  { 'live.isResponded': { $exists: false } }
                ]
              }
            ]
          }
          break
        case 3:
          match['live.isConnected'] = true
          match['live.isResponded'] = true
          break
        case 4:
          if (!match.$and) {
            match.$and = []
          }
          match.$and.push({
            c: {
              $not: {
                $elemMatch: {
                  inputType: 'live'
                }
              }
            }
          })
          match['live.isConnected'] = false
          match['live.isResponded'] = false
          break
        case 5:
          break
      }
    }

    // BEGIN: RATING
    if (advancedSearch.rating.length > 0) {
      match.rating = {
        $in: advancedSearch.rating
      }
    }

    //BEGIN: KNOWLEDGEBASE
    if (advancedSearch.faqCategory && advancedSearch.faqCategory !== 'all') {
      match.faqCategory = advancedSearch.faqCategory
    } else {
      delete match.faqCategory
    }

    //BEGIN: GENAI
    if (advancedSearch.r && advancedSearch.r !== 'all') {
      match.r = advancedSearch.r
    } else {
      delete match.r
    }

    // BEGIN: DEPARTMENTS
    if (!advancedSearch.departments.includes('all') && advancedSearch.departments.length > 0) {
      let listDepartmentsOld = []
      await this.asyncForEach(advancedSearch.departments, async matchDepartment => {
        await this.asyncForEach(advancedOptions.departments, async optionDepartment => {
          if (matchDepartment === optionDepartment.value) {
            listDepartmentsOld.push(optionDepartment.label)
          }
        })
      })
      let matchDepartments = {
        $or: [{
          'zion.departments': {
            $in: advancedSearch.departments
          }
        }, {
          'liveChat.department': {
            $in: listDepartmentsOld
          }
        }]
      }
      if (match.$and) {
        match.$and.push(matchDepartments)
      } else {
        match.$and = [matchDepartments]
      }
    }

    // BEGIN: HB
    // Accepts the legacy single-string value (saved filters) and the new
    // multi-select array; see utils/channelFilter.js for the semantics.
    applyHbSelectionToMatch(match, advancedSearch.hb)

    // BEGIN: DIALOGUE
    if (advancedSearch.dialogue) {
      if (advancedSearch.dialogue === 'active') {
        if (match.$or) {
          match.$or.push(
            {
              'c.0.template_hsm': { $exists: true }
            }
          )
          match.$or.push(
            {
              'c.0.custom': { $exists: true }
            }
          )
        } else {
          match.$or = [
            {
              'c.0.template_hsm': { $exists: true }
            },
            {
              'c.0.custom': { $exists: true }
            }
          ]
        }
      } else if (advancedSearch.dialogue === 'receptive') {
        if (match.$and) {
          match.$and.push(
            {
              'c.0.template_hsm': { $exists: false }
            }
          )
          match.$and.push(
            {
              'c.0.custom': { $exists: false }
            }
          )
        } else {
          match.$and = [
            {
              'c.0.template_hsm': { $exists: false }
            },
            {
              'c.0.custom': { $exists: false }
            }
          ]
        }
      }
    }

    if (advancedSearch?.referrals?.source_id) {
      match['referrals.source_id'] = advancedSearch.referrals.source_id
    }
    return match
  },
  async requestMatchCrm() {
    let match = {
      accountId: this.account._id
    }
    let advancedSearchCrm = await Utils.asyncClone(this.advancedSearchCrm.match)
    // BEGIN: _ID
    if (advancedSearchCrm.cResponse.match(/^[0-9a-fA-F]{24}$/)) {
      match._id = advancedSearchCrm.cResponse
    }
    // BEGIN: C -> RESPONSE AND IDENTIFIERS
    if (advancedSearchCrm.cResponse && advancedSearchCrm.cResponse.length >= 2) {
      if (!match.$and) {
        match.$and = []
      }
      let cResponse = {}
      cResponse = { $regex: advancedSearchCrm.cResponse, $options: 'i' }
      match.$and.push({
        "fields.fields.value": cResponse
      })
    }

    // BEGIN: TAGS
    if (!advancedSearchCrm.tags.includes('all') && advancedSearchCrm.tags.length > 0) {
      match.tags = {
        $in: advancedSearchCrm.tags
      }
    }
    //BRGIN: DYNAMIC FILTER
    if (advancedSearchCrm.dynamicFilter && advancedSearchCrm.dynamicFilter.length) {
      await this.asyncForEach(advancedSearchCrm.dynamicFilter, filter => {
        if ((filter.field && filter.field !== '') && (filter.condition && filter.condition !== '') && ((filter.value && filter.value !== '' && filter.condition !== 3 && filter.condition !== 4) || (filter.value === '' && (filter.condition === 3 || filter.condition === 4)))) {
          let finder = {}
          if (!match.$and) {
            match.$and = []
          }
          switch (filter.condition) {
            case 1:
              finder = { 'fields.fields': { $elemMatch: { id: filter.field, value: filter.value } } }
              break
            case 2:
              finder = { 'fields.fields': { $elemMatch: { id: filter.field, value: { $ne: filter.value } } } }
              break
            case 3:
              finder = { 'fields.fields': { $elemMatch: { id: filter.field, value: { $ne: '', $exists: true } } } }
              break
            case 4:
              finder = { $or: [{ 'fields.fields': { $elemMatch: { id: filter.field, value: { $eq: '', $exists: true } } } }, { 'fields.fields.id': { $ne: filter.field } }] }
              break
            case 5:
              finder = { 'fields.fields': { $elemMatch: { id: filter.field, value: { $regex: filter.value, $options: 'i' } } } }
              break
            case 6:
              finder = { 'fields.fields': { $elemMatch: { id: filter.field, value: { $not: { $regex: filter.value, $options: 'i' } } } } }
              break
            case 7:
              finder = { 'fields.fields': { $elemMatch: { id: filter.field, value: { $gt: Number(filter.value) } } } }
              break
            case 8:
              finder = { 'fields.fields': { $elemMatch: { id: filter.field, value: { $lt: Number(filter.value) } } } }
              break
            default:
              finder = {}
              break
          }
          match.$and.push(finder)
        }
      })

    }


    return match
  },
  title: '',
  bots: [],
  botGroups: [],
  selectedBotGroupId: null,
  botsDeleted: [],
  botsName: {},
  botsId: {},
  botsRaw: {},
  botsById: {},
  botsSelectable: [],
  botsIdentifiers: {},
  bot: {},
  tags: {},
  tagsOptions: [],
  tagsOptionsPeople: [],
  tagsOptionsCompanies: [],
  users: {},
  // Contador da última listagem completa (/user/list/all). Serve de guard em loadUsers:
  // main.users sozinho não diz se a lista chegou, porque updateUserStatus cria entradas parciais.
  usersCount: 0,
  usersOptions: [],
  dark: false,
  token: null,
  localization: 'en-US',
  userInfo: {},
  user: {},
  account: {},
  zion: {
    status: -5
  },
  whatsapp: {
    versionOptions: [
      {
        label: 'Desabilitado',
        value: 0
      },
      {
        label: 'Globalbot WhatsApp',
        value: 5
      },
      {
        label: 'Meta WhatsApp',
        value: 6
      },
      {
        label: 'Cogna WhatsApp',
        value: 7
      },
      {
        label: 'WhatsApp QR Code',
        value: 8
      }
    ]
  },
  liveAttendantSettings: {
    attendantBell: '',
    messageBell: '',
    sortType: -11,
    exhibition: false,
    exhibitionType: 1,
    exhibitionAlertTime: 1,
    lastDepartmentId: ''
  },
  liveSettings: {
    initiations: {
      email: false,
      sms: false,
      whatsapp: false,
      facebook: false
    },
    away: {
      isActive: false,
      options: []
    },
    awayAuto: {
      isActive: false,
      time: 5
    },
    exhibitions: {
      manager: 1,
      attendant: 1
    },
    archive: {
      time: 120
    },
    finishOption: {
      tags: {
        isActive: false,
        mandatory: false,
      },
      monetaryValue: {
        isActive: false,
        mandatory: false,
        currency: 'BRL'
      },
    },
    messages: {
      "pt-BR": {
        finishRoom: "A conversa foi finalizada.",
        archiveRoom: "A conversa foi arquivada.",
        transferRoom: "A conversa foi transferida.",
        withAttendant: "Com atendente.",
        available: "Disponível.",
        queue: "Em fila.",
        queueDistribution: "Em fila automática.",
        waiting: "Aguardando.",
        noVacancy: "Nenhum atendente no momento."
      },
      "en-US": {
        finishRoom: "The conversation ended.",
        archiveRoom: "The conversation has been archived.",
        transferRoom: "The conversation was transferred.",
        withAttendant: "With attendant.",
        available: "Available.",
        queue: "In line.",
        queueDistribution: "Automatic queued",
        waiting: "Waiting.",
        noVacancy: "No attendant at the moment."
      },
      "es-ES": {
        finishRoom: "La conversación terminó.",
        archiveRoom: "La conversación se ha archivado.",
        transferRoom: "La conversación fue transferida.",
        withAttendant: "Con asistente.",
        available: "Disponible.",
        queue: "En fila.",
        queueDistribution: "Cola automática",
        waiting: "Esperando",
        noVacancy: "No hay asistentes por el momento."
      }
    }
  },
  liveDepartment: {},
  liveDepartments: [],
  liveDepartmentsOptions: [],
  department: {},
  socket: null,
  credits: 0,
  liveQuery: {
    isMaster: true,
    masterId: null,
    masterName: null,
    masterEmail: null,
    masterRole: null,
    masterAvatar: null,
    tokens: [],
    category: null,
    department: null
  },
  liveStatus: 1,
  preferences: {
    conversation: {},
    live: {}
  },
  audio: {
    isRecording: false
  },
  MASTERS_STATUS: {
    ONLINE: 5,
    AWAY: 3,
    OFFLINE: 1
  },
  permission: {
    _id: null,
    accountId: null,
    realtime: {
      10: {},
      11: {},
      12: {},
      13: {},
      14: {},
      15: {}
    },
    analytics: {
      10: {},
      11: {},
      12: {},
      13: {},
      14: {},
      15: {}
    },
    conversations: {
      10: {
        view: 'all'
      },
      11: {
        view: 'all'
      },
      12: {
        view: 'all'
      },
      13: {
        view: 'all'
      },
      14: {
        view: 'bots'
      },
      15: {
        view: 'bots'
      }
    },
    flow: {
      10: {},
      11: {},
      12: {},
      13: {},
      14: {},
      15: {}
    },
    knowledge: {
      10: {},
      11: {},
      12: {},
      13: {},
      14: {},
      15: {}
    },
    broadcast: {
      10: {},
      11: {},
      12: {},
      13: {},
      14: {},
      15: {}
    },
    live: {
      10: {},
      11: {},
      12: {},
      13: {},
      14: {},
      15: {}
    },
    library: {
      10: {},
      11: {},
      12: {},
      13: {},
      14: {},
      15: {}
    },
    settings: {
      10: {},
      11: {},
      12: {},
      13: {},
      14: {},
      15: {}
    }
  },
  templates: [],
  kanban: {
    boards: [],
    columns: {},///maped by boardId
    cards: {},///maped by columnId
  }
} 